import clsx from 'clsx';
import { useT } from '../i18n';
import { PULL_TRIGGER_PX } from '../lib/usePullToRefresh';

/** The strip that opens above a list while it is pulled down to refresh (phones only). */
export function PullIndicator({ pull, refreshing }: { pull: number; refreshing: boolean }) {
  const t = useT();
  if (pull <= 0 && !refreshing) return null;
  const armed = refreshing || pull >= PULL_TRIGGER_PX;
  return (
    <div
      className="nv-pull"
      style={{ height: refreshing ? PULL_TRIGGER_PX * 0.75 : pull }}
      role="status"
      aria-live="polite"
    >
      <span className={clsx('nv-pull-dot', armed && 'nv-on', refreshing && 'nv-spin')} />
      <span>{t(refreshing ? 'pullRefreshing' : armed ? 'pullRelease' : 'pullToRefresh')}</span>
    </div>
  );
}
